import React, { useEffect, useState } from "react";
import "./ResponsiveFallback.scss";

const ResponsiveFallback = ({ minWidth = 990, fallbackMessage, children }) => {
  const [isFallback, setIsFallback] = useState(false); // Tracks if screen width is below minWidth
  const [isModalVisible, setIsModalVisible] = useState(false); // Tracks if the modal should be shown

  const checkViewport = () => {
    const shouldFallback = window.innerWidth < minWidth;
    setIsFallback(shouldFallback);
    setIsModalVisible(shouldFallback); // Show or hide modal based on viewport
  };

  useEffect(() => {
    checkViewport(); // Check viewport on load
    window.addEventListener("resize", checkViewport);
    return () => window.removeEventListener("resize", checkViewport); // Cleanup
  }, [minWidth]);

  const handleOkayClick = () => {
    setIsModalVisible(false); // Close the modal
  };

  return (
    <>
      {isModalVisible && (
        <div className="fallback-screen">
          <div className="fallback-message-box">
            <div className="fallback-message-title">Warning</div>
            <div className="fallback-message-body">
              {fallbackMessage}
              <button className="fallback-ok-button" onClick={handleOkayClick}>
                Okay
              </button>
            </div>
          </div>
        </div>
      )}
      <div className={isModalVisible ? "background-dimmed" : ""}>
        {children}
      </div>
    </>
  );
};

export default ResponsiveFallback;
